// @flow
import React from 'react';
import { type ContextRouter, type Match, withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { Helmet } from 'react-helmet';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import SavesTemplate from 'components/saves/SavesTemplate';
import SavePostCardListContainer from 'containers/saves/SavePostCardListContainer';
import SaveProductCardListContainer from 'containers/saves/SaveProductCardListContainer';
import PageTemplate from "components/base/PageTemplate";

type Props = {
  match: Match,
} & ContextRouter;

const Saves = (props: Props) => {
  const search = queryString.parse(props.location.search);
  return (
    <PageTemplate>
      <header>
        <MainHeadContainer />
        <MainMobileHeadContainer />
      </header>
      <SavesTemplate>
        <Helmet>
          <title>임시 컨텐츠 목록 | 캐시바이</title>
        </Helmet>
        {search.type === 'product' ? (
          <SaveProductCardListContainer />
        ) : (
          <SavePostCardListContainer />
        )}
      </SavesTemplate>
      <MainMobileFooter />
    </PageTemplate>
  );
};

export default withRouter(Saves);



// WEBPACK FOOTER //
// ./src/pages/Saves.js